import { MapTo } from '@adobe/aem-react-editable-components';
import HeroComponent, { HeroComponentEditConfig } from './HeroComponent';

export default MapTo('cob-corp-acquisition/components/creditonebank/hero-component')(HeroComponent, HeroComponentEditConfig);